// Your actions (ClientSpace.dc.html): the actions agreed at the last session, ticked off by the client
// as they go (only done_at changes), with "Add an action for session 3" in Adam's view. A ticked
// action is struck through. While staff view as the client nothing can be ticked.
import { useState } from 'react'
import { readOnlyControl } from '../../lib/viewAs.jsx'
import { COPY } from './copy.js'
import { actionsView, actionTarget } from './model.js'
import { addAction, tickAction } from './data.js'

export function ActionsSection({ ctx, empty = false }) {
  const { actions, sessions, staff, open, viewingAs, patch, nowMs, me } = ctx
  const view = actionsView(actions, sessions)
  const [msg, setMsg] = useState(null)
  const canAdd = staff && open
  if (!view.total && !canAdd) return empty ? <p className="ms-empty">{COPY.noActions}</p> : null

  async function toggle(a) {
    const done = !a.done_at
    const at = done ? new Date().toISOString() : null
    setMsg(null)
    patch(d => ({ ...d, actions: d.actions.map(x => (x.id === a.id ? { ...x, done_at: at } : x)) }))
    try {
      await tickAction(a.id, done)
    } catch {
      patch(d => ({ ...d, actions: d.actions.map(x => (x.id === a.id ? { ...x, done_at: a.done_at } : x)) }))
      setMsg(COPY.notSaved)
    }
  }

  return (
    <section className="ms-card" data-part="actions" aria-labelledby="ms-actions-h">
      <div className="ms-card-head ms-card-head--split">
        <div className="ms-card-titles">
          <h2 className="ms-h2" id="ms-actions-h">{COPY.actionsH2}</h2>
          {view.agreed && <span className="ms-card-sub">{COPY.agreedAt(view.agreed.number, view.agreed.date)}</span>}
        </div>
        {view.total > 0 && <span className="ms-count">{COPY.actionCount(view.done, view.total)}</span>}
      </div>
      {view.items.map(a => (
        <label key={a.id} className={a.done_at ? 'ms-action ms-action--done' : 'ms-action'}>
          <input type="checkbox" checked={Boolean(a.done_at)} onChange={() => toggle(a)}
            disabled={viewingAs || !open} {...readOnlyControl(viewingAs)} />
          <span className="ms-action-text">{a.body}</span>
        </label>
      ))}
      {canAdd && <AddAction ctx={ctx} view={view} target={actionTarget(sessions, nowMs)} me={me} onFail={setMsg} />}
      {msg && <p className="ms-card-msg" role="alert">{msg}</p>}
      <p className="ms-card-foot">{COPY.actionsFoot}</p>
    </section>
  )
}

function AddAction({ ctx, view, target, me, onFail }) {
  const { space, patch } = ctx
  const [text, setText] = useState('')
  const [busy, setBusy] = useState(false)

  async function add(e) {
    e.preventDefault()
    const body = text.trim()
    if (!body || busy) return
    setBusy(true)
    onFail(null)
    try {
      const row = await addAction({ spaceId: space.id, agreedSessionId: target.agreedSessionId, body, sortOrder: view.nextSort, createdBy: me.person.id })
      patch(d => ({ ...d, actions: [...d.actions, row] }))
      setText('')
    } catch {
      onFail(COPY.notSaved)
    } finally {
      setBusy(false)
    }
  }

  return (
    <form className="ms-add" onSubmit={add}>
      <input aria-label={COPY.newActionAria} value={text} maxLength={500} placeholder={COPY.newActionPlaceholder(target.forNumber)}
        onChange={e => setText(e.target.value)} />
      <button type="submit" className="ms-btn ms-btn--small" disabled={busy}>{COPY.addAction}</button>
    </form>
  )
}
